import Disgrow from "disgrow";
import { botId, memCacheExpire, alertOnFetch } from "../config";
import lscache from "lscache";
import axios from "axios";

export function getRandomColor() {
  let letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export async function getInfo() {
  const bot = new Disgrow(botId);
  const info = await bot.myStats().catch(err => {
    alert("Error: " + err);
  });
  return info;
}

export const botInfo = async () => {
  const info = await getInfo();
  return info;
};

export const fetchDataServive = async () => {
  if (lscache.get("service_datax")) {
    const fetchStatus = lscache.get("service_datax");
    return JSON.parse(fetchStatus);
  } else {
    const status1 = await axios.get("https://scathachbot.xyz/api/health1");
    const status2 = await axios.get("https://scathachbot.xyz/api/health0");

    const data = {
      status1: status1.data,
      status2: status2.data
    };

    lscache.set("service_datax", JSON.stringify(data), memCacheExpire);
    return data;
  }
};

export const fetchDataCommands = async () => {
  if (lscache.get("cmd_data")) {
    const fetchStatus = lscache.get("cmd_data");
    return JSON.parse(fetchStatus);
  } else {
    const cmd = await axios.get("https://scathachbot.xyz/api/slashcount");
    const cmd2 = await axios.get("https://scathachbot.xyz/api/cmdcount");

    const data = {
      cmd: cmd.data,
      cmd2: cmd2.data,
    };

    lscache.set("cmd_data", JSON.stringify(data), memCacheExpire);
    return data;
  }
};

export const fetchMusicFilter = async () => {
  if (lscache.get("music_filters")) {
    const fetchStatus = lscache.get("music_filters");
    return JSON.parse(fetchStatus);
  } else {
    const filter = await axios.get("https://scathachbot.xyz/api/music");
    lscache.set("music_filters", JSON.stringify(filter.data), memCacheExpire);
    return filter.data;
  }
};

export const fetchAutoTrigger = async () => {
  if (lscache.get("trigger_data")) {
    const fetchStatus = lscache.get("trigger_data");
    return JSON.parse(fetchStatus);
  } else {
    const filter = await axios.get("https://scathachbot.xyz/api/trigger");
    lscache.set("trigger_data", JSON.stringify(filter.data), memCacheExpire);
    return filter.data;
  }
};

export const fetchAutomated = async () => {
  if (lscache.get("automated_data")) {
    const fetchStatus = lscache.get("automated_data");
    return JSON.parse(fetchStatus);
  } else {
    const filter = await axios.get("https://scathachbot.xyz/api/automation");
    lscache.set("automated_data", JSON.stringify(filter.data), memCacheExpire);
    return filter.data;
  }
};



export const inMemoryBotInfo = async () => {
  if (!lscache.get("bot_data")) {
    switch (alertOnFetch) {
    case true:
      alert("api firing");
      break;

    case false:
      console.log("api firing");
      break;
    }

    const fetchBot = await getInfo();
    lscache.set("bot_data", JSON.stringify(fetchBot), memCacheExpire);
    return fetchBot;
  } else {
    switch (alertOnFetch) {
    case true:
      alert("api does not firing");
      break;

    case false:
      console.log("api does not firing");
      break;
    }
    const fetchBotFromCache = lscache.get("bot_data");
    return JSON.parse(fetchBotFromCache);
  }

};

export const wsInfo = async () => {
  if (!lscache.get("bot_ws")) {
    switch (alertOnFetch) {
    case true:
      alert("bot_ws api firing");
      break;

    case false:
      console.log("bot_ws api firing");
      break;
    }

    const fetchBot = await axios.get("https://scathachbot.xyz/api/ws");
    lscache.set("bot_ws", JSON.stringify(fetchBot.data), 10);
    return fetchBot.data;
  } else {
    switch (alertOnFetch) {
    case true:
      alert("bot_ws api does not firing");
      break;

    case false:
      console.log("bot_ws api does not firing");
      break;
    }
    const fetchBotFromCache = lscache.get("bot_ws");
    return JSON.parse(fetchBotFromCache);
  }

};

export const lavalinkInfo = async () => {
  if (!lscache.get("bot_lavalink")) {
    switch (alertOnFetch) {
    case true:
      alert("bot_lavalink api firing");
      break;

    case false:
      console.log("bot_lavalink api firing");
      break;
    }

    const fetchBot = await axios.get("https://scathachbot.xyz/api/lavalink");
    lscache.set("bot_lavalink", JSON.stringify(fetchBot.data), 10);
    return fetchBot.data;
  } else {
    switch (alertOnFetch) {
    case true:
      alert("bot_lavalink api does not firing");
      break;

    case false:
      console.log("bot_lavalink api does not firing");
      break;
    }
    const fetchBotFromCache = lscache.get("bot_lavalink");
    return JSON.parse(fetchBotFromCache);
  }

};


export const bumpInfo = async () => {
  if (!lscache.get("bot_bump")) {
    switch (alertOnFetch) {
    case true:
      alert("bot_bump api firing");
      break;

    case false:
      console.log("bot_bump api firing");
      break;
    }

    const fetchBot = await axios.get("https://scathachbot.xyz/api/bump");
    lscache.set("bot_bump", JSON.stringify(fetchBot.data), 5);
    return fetchBot.data;
  } else {
    switch (alertOnFetch) {
    case true:
      alert("bot_bump api does not firing");
      break;

    case false:
      console.log("bot_bump api does not firing");
      break;
    }
    const fetchBotFromCache = lscache.get("bot_bump");
    return JSON.parse(fetchBotFromCache);
  }

};


export const patreonInfo = async () => {
  if (!lscache.get("patreon_insight")) {
    switch (alertOnFetch) {
    case true:
      alert("patreon_insight api firing");
      break;

    case false:
      console.log("patreon_insight api firing");
      break;
    }

    const fetchBot = await axios.get("https://scathachbot.xyz/api/patreon_insight");
    lscache.set("patreon_insight", JSON.stringify(fetchBot.data), 1);
    return fetchBot.data;
  } else {
    switch (alertOnFetch) {
    case true:
      alert("patreon_insight api does not firing");
      break;

    case false:
      console.log("patreon_insight api does not firing");
      break;
    }
    const fetchBotFromCache = lscache.get("patreon_insight");
    return JSON.parse(fetchBotFromCache);
  }

};
